import { render, staticRenderFns } from "./CodeBlock.vue?vue&type=template&id=081ca873"
import script from "./CodeBlock.vue?vue&type=script&lang=ts"
export * from "./CodeBlock.vue?vue&type=script&lang=ts"
import style0 from "./CodeBlock.vue?vue&type=style&index=0&id=081ca873&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports